(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutrio-offer-calendar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nutrio-offer-calendar')) {
  class NutrioOfferCalendar extends HTMLElement {
    connectedCallback() {
      this.stops = [...this.querySelectorAll('[data-round]')];
      if (!this.stops.length) return;
      this.content = this.querySelector('[data-panel-content]');
      this.rail = this.querySelector('.bn-schedule__rail');
      this.root = this.closest('.vk-fn');
      this.syncClock(Number(this.dataset.serverNowMs));
      this.retryCount = 0; this.nextRefreshAt = 0; this.retryExhausted = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const stop = event.target.closest('[data-round]');
        if (stop) { this.manual = true; this.select(stop, true); this.tick(); }
        if (event.target.closest('[data-reminder]')) this.saveReminder();
        if (event.target.closest('[data-retry]')) {
          this.retryCount = 0; this.retryExhausted = false; this.nextRefreshAt = 0;
          this.refreshOffers();
        }
      }, options);
      this.root.addEventListener('click', event => {
        const link = event.target.closest('[data-bn-offers-link]');
        if (!link) return;
        event.preventDefault();
        this.showCurrentOffers();
      }, options);
      this.root.addEventListener('submit', event => {
        if (!event.target.matches('[data-bn-cart-form]')) return;
        event.preventDefault(); this.addToCart(event.target);
      }, options);
      this.rail.addEventListener('keydown', event => {
        const index = this.stops.indexOf(event.target.closest('[data-round]'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.stops.length;
        if (event.key === 'ArrowLeft') next = (index + this.stops.length - 1) % this.stops.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.stops.length - 1;
        if (next === undefined) return;
        event.preventDefault(); this.stops[next].focus({ preventScroll: true });
        this.manual = true; this.select(this.stops[next], true); this.tick();
      }, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { this.tick(); if (!this.retryCount && !this.retryExhausted) this.refreshOffers(true); } }, options);
      document.addEventListener('shopify:block:select', event => {
        const stop = this.stops.find(item => item.dataset.round === event.detail.blockId);
        if (stop) { this.manual = true; this.select(stop); this.tick(); }
      }, options);
      this.fresh = false; this.tick();
      if (!this.expired) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.refreshAbort?.abort(); }
    syncClock(serverNow) {
      if (!Number.isFinite(serverNow) || serverNow <= 0) return false;
      this.serverNow = serverNow; this.clockAt = performance.now(); return true;
    }
    now() { return this.serverNow + (performance.now() - this.clockAt); }
    captureFocus() {
      const element = document.activeElement;
      if (!element) return null;
      for (const area of ['[data-panel-content]', '[data-monthly-slot]', '[data-bn-flash-slot]']) {
        const container = this.root.querySelector(area);
        if (!container?.contains(element)) continue;
        const matches = [...container.querySelectorAll('a,button,summary,input,select,textarea,[tabindex="-1"]')].filter(item => item.tagName === element.tagName && item.getAttribute('href') === element.getAttribute('href') && item.className === element.className);
        return { area, tag: element.tagName, href: element.getAttribute('href'), className: element.className, index: matches.indexOf(element) };
      }
      return null;
    }
    restoreFocus(saved) {
      if (!saved) return;
      const container = this.root.querySelector(saved.area);
      const matches = [...(container?.querySelectorAll('a,button,summary,input,select,textarea,[tabindex="-1"]') || [])].filter(item => item.tagName === saved.tag && item.getAttribute('href') === saved.href && item.className === saved.className);
      const target = matches[saved.index];
      if (target && !target.closest('[hidden]')) target.focus({ preventScroll: true });
      else this.selected?.focus({ preventScroll: true });
    }
    expire() {
      this.expired = true; this.fresh = false; this.nextRefreshAt = Infinity;
      clearInterval(this.timer);
      document.querySelectorAll('[data-nutrio-announcement-end]').forEach(item => item.remove());
      this.root.remove();
    }
    end(value) {
      const timestamp = Date.parse(value);
      return Number.isFinite(timestamp) ? timestamp + (60 - new Date(timestamp).getUTCSeconds()) * 1000 : NaN;
    }
    state(stop, now = this.now()) {
      const start = Date.parse(stop.dataset.start), end = this.end(stop.dataset.end);
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 'pending';
      if (now >= end) return 'past';
      return now >= start ? 'active' : 'upcoming';
    }
    cyberState(now = this.now()) { return this.state({ dataset: { start: this.dataset.cyberStart, end: this.dataset.cyberEnd } }, now); }
    monthState(now = this.now()) { return this.state({ dataset: { start: this.dataset.monthStart, end: this.dataset.monthEnd } }, now); }
    phase(now = this.now()) {
      if (now >= this.end(this.dataset.monthEnd)) return 'none';
      if (now < Date.parse(this.dataset.monthStart)) return now < this.end(this.dataset.legacyEnd) ? 'legacy' : 'none';
      const active = this.stops.find(stop => this.state(stop, now) === 'active');
      if (active) return active.dataset.round;
      return this.cyberState(now) === 'active' ? 'cyber' : 'none';
    }
    date(value) {
      const locale = document.documentElement.lang || 'hu';
      const hungarian = /^hu(?:-|$)/i.test(locale);
      const formatter = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Budapest', month: hungarian ? 'long' : 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      const date = new Date(value);
      if (!hungarian) return formatter.format(date);
      const parts = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
      const month = parts.month.charAt(0).toLocaleUpperCase(locale) + parts.month.slice(1);
      return `${month} ${parts.day}., ${parts.hour.padStart(2, '0')}:${parts.minute}`;
    }
    duration(milliseconds) {
      const minutes = Math.ceil(Math.max(0, milliseconds) / 60000);
      if (minutes < 1) return this.dataset.soon;
      const days = Math.floor(minutes / 1440), hours = Math.floor(minutes % 1440 / 60), remainder = minutes % 60;
      return [days ? `${days} ${this.dataset.days}` : '', hours ? `${hours} ${this.dataset.hours}` : '', `${remainder} ${this.dataset.minutes}`].filter(Boolean).join(' ');
    }
    tick() {
      if (!this.isConnected || document.hidden) return;
      const now = this.now();
      if (now >= this.end(this.dataset.monthEnd)) { this.expire(); return; }
      const active = this.stops.find(stop => this.state(stop, now) === 'active');
      const next = this.stops.find(stop => this.state(stop, now) === 'upcoming');
      const preferred = active || next || this.stops[this.stops.length - 1];
      this.stops.forEach(stop => {
        const state = this.state(stop, now); stop.dataset.state = state;
        stop.querySelector('[data-status]').textContent = this.dataset[state === 'upcoming' && stop === next ? 'next' : state];
      });
      const phase = this.phase(now);
      const signature = `${this.stops.map(stop => stop.dataset.state).join('|')}|${this.cyberState(now)}|${this.monthState(now)}|${phase}`;
      const boundary = this.signature && this.signature !== signature;
      if (boundary) { this.fresh = false; this.manual = false; if (!this.retryCount && !this.retryExhausted) this.nextRefreshAt = 0; }
      if (!this.selected || boundary) this.select(preferred);
      this.signature = signature;
      const slot = this.root.querySelector('[data-bn-flash-slot]');
      if (slot) {
        slot.hidden = !this.fresh || slot.dataset.phase !== phase;
        const countdown = slot.querySelector('[data-flash-countdown]');
        if (countdown) countdown.textContent = this.duration(Number(slot.dataset.endMs) - now);
      }
      const value = this.content.querySelector('[data-timing-value]');
      if (value && this.state(this.selected, now) === 'active') value.textContent = this.duration(this.end(this.selected.dataset.end) - now);
      const footer = this.querySelector('[data-next-info]'); footer.hidden = !next || next === this.selected;
      if (next) {
        this.querySelector('[data-next-title]').textContent = next.dataset.title;
        const date = this.querySelector('[data-next-date]'); date.textContent = this.date(next.dataset.start); date.dateTime = next.dataset.start;
      }
      const prices = this.querySelector('[data-month-prices]');
      if (prices) prices.hidden = this.monthState(now) !== 'active' || !this.fresh;
      if (!this.retryExhausted && performance.now() >= this.nextRefreshAt) this.refreshOffers();
    }
    select(stop, animate = false) {
      const previous = this.selected; this.selected = stop; this.renderedState = this.state(stop);
      this.stops.forEach(item => item.setAttribute('aria-pressed', String(item === stop)));
      const template = this.querySelector(`template[data-preview="${stop.dataset.round}"]`);
      this.content.replaceChildren(template.content.cloneNode(true));
      const active = this.renderedState === 'active', future = this.renderedState === 'upcoming';
      const next = this.stops.find(item => this.state(item) === 'upcoming');
      this.content.querySelector('[data-panel-status]').textContent = this.dataset[future && stop === next ? 'next' : this.renderedState];
      this.content.querySelector('[data-reminder]').hidden = !future;
      this.content.querySelector('[data-timing-label]').textContent = active ? this.dataset.until : future ? this.dataset.starts : this.dataset[this.renderedState];
      this.content.querySelector('[data-timing-value]').textContent = active ? this.duration(this.end(stop.dataset.end) - this.now()) : future ? this.date(stop.dataset.start) : this.renderedState === 'past' ? this.dataset.ended : '';
      const offers = this.content.querySelector('[data-offers]');
      offers.hidden = !(active && this.fresh && Number(offers.dataset.count) > 0);
      this.content.querySelector('[data-flash-price]').hidden = !(active && this.fresh);
      this.content.querySelector('[data-availability]').hidden = !(active && !this.fresh);
      this.content.querySelector('[data-friday-preview]').hidden = !(stop === this.stops[this.stops.length - 1] && future && this.now() >= Date.parse(stop.dataset.start) - 2 * 86400000);
      const cyber = this.content.querySelector('[data-cyber-products]');
      if (cyber) {
        cyber.hidden = !(this.cyberState() === 'active' && this.fresh);
        this.content.querySelector('[data-cyber-status]').textContent = this.dataset[this.cyberState()];
      }
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (animate && !reduced) this.content.animate([{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'cubic-bezier(.2,.7,.3,1)' });
      if (previous !== stop) this.rail.scrollTo({ left: stop.offsetLeft - this.rail.offsetLeft - (this.rail.clientWidth - stop.clientWidth) / 2, behavior: animate && !reduced ? 'smooth' : 'instant' });
    }
    showCurrentOffers() {
      this.tick();
      const active = this.stops.find(stop => this.state(stop) === 'active');
      const fallback = () => this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (!active || !this.fresh || this.expired) { fallback(); return; }
      this.manual = true; this.select(active);
      const offers = this.content.querySelector('[data-offers]');
      if (!offers || offers.hidden) { fallback(); return; }
      const more = offers.querySelector('details');
      if (more) more.open = true;
      const heading = offers.querySelector('h5');
      if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      offers.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    async refreshOffers(force = false) {
      if (this.expired || this.retryExhausted || this.refreshBusy || this.cartBusy || !this.isConnected || document.hidden || (!force && performance.now() < this.nextRefreshAt)) return;
      this.refreshBusy = true; this.nextRefreshAt = Infinity;
      const controller = new AbortController(); this.refreshAbort = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(location.href); url.searchParams.set('section_id', this.dataset.sectionId); url.searchParams.set('_bn', String(performance.now()));
        const response = await fetch(url, { cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('section response');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector(`nutrio-offer-calendar[data-section-id="${this.dataset.sectionId}"]`);
        const slot = doc.querySelector('[data-bn-flash-slot]');
        const serverNow = Number(fresh?.dataset.serverNowMs);
        const responseTime = Date.parse(response.headers.get('Date') || '');
        if (!fresh && doc.getElementById(`shopify-section-${this.dataset.sectionId}`) && !doc.querySelector('.vk-fn') && responseTime >= this.end(this.dataset.monthEnd)) { this.syncClock(responseTime); this.expire(); return; }
        if (!fresh || !Number.isFinite(serverNow) || serverNow <= 0 || !slot || slot.dataset.phase !== this.phase(serverNow) || fresh.querySelectorAll('template[data-preview]').length !== this.stops.length) throw new Error('section state');
        if (this.cartBusy) { this.nextRefreshAt = performance.now(); return; }
        const phaseChanged = this.phase() !== this.phase(serverNow);
        this.syncClock(serverNow);
        if (serverNow >= this.end(this.dataset.monthEnd)) { this.expire(); return; }
        const focused = this.captureFocus();
        fresh.querySelectorAll('template[data-preview]').forEach(template => {
          const current = this.querySelector(`template[data-preview="${template.dataset.preview}"]`);
          if (current) current.replaceWith(template.cloneNode(true));
        });
        const currentSlot = this.root.querySelector('[data-bn-flash-slot]');
        if (currentSlot.innerHTML !== slot.innerHTML || currentSlot.dataset.phase !== slot.dataset.phase) currentSlot.replaceWith(slot.cloneNode(true));
        else currentSlot.hidden = false;
        const monthly = this.querySelector('[data-monthly-slot]'), newMonthly = fresh.querySelector('[data-monthly-slot]');
        if (monthly && newMonthly && monthly.innerHTML !== newMonthly.innerHTML) {
          const expanded = monthly.querySelector('details')?.open;
          monthly.replaceChildren(...newMonthly.cloneNode(true).childNodes);
          if (expanded) monthly.querySelector('details').open = true;
        }
        this.fresh = true; this.dataset.refresh = 'ready'; this.signature = null;
        this.retryCount = 0; this.retryExhausted = false; this.nextRefreshAt = performance.now() + 60000;
        this.querySelector('[data-refresh-notice]').hidden = true;
        const expanded = this.content.querySelector('details')?.open;
        const preferred = this.stops.find(stop => this.state(stop) === 'active') || this.stops.find(stop => this.state(stop) === 'upcoming') || this.stops[this.stops.length - 1];
        this.select(phaseChanged ? preferred : this.selected || preferred);
        if (expanded && this.content.querySelector('details')) this.content.querySelector('details').open = true;
        this.tick();
        this.restoreFocus(focused);
      } catch (error) {
        this.fresh = false; this.dataset.refresh = 'unavailable';
        const delays = [5000, 15000, 45000];
        if (this.retryCount < delays.length) this.nextRefreshAt = performance.now() + delays[this.retryCount++];
        else { this.retryExhausted = true; this.nextRefreshAt = Infinity; }
        const currentSlot = this.root.querySelector('[data-bn-flash-slot]'); if (currentSlot) currentSlot.hidden = true;
        const focused = this.captureFocus();
        if (this.selected) this.select(this.selected);
        this.restoreFocus(focused);
        this.querySelector('[data-refresh-notice]').hidden = !this.retryExhausted;
      }
      finally { clearTimeout(timeout); this.refreshBusy = false; }
    }
    async addToCart(form) {
      const slot = form.closest('[data-bn-flash-slot]');
      if (this.cartBusy || !this.fresh || slot.dataset.phase !== this.phase() || this.now() >= Number(slot.dataset.endMs)) { this.tick(); return; }
      this.cartBusy = true;
      const button = form.querySelector('button'), message = slot.querySelector('[data-cart-message]');
      button.disabled = true; message.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let outcomeUnknown = true;
      try {
        const drawer = document.getElementById('CartDrawer');
        let sections = [];
        try { sections = window.xCartHelper?.getSectionsToRender(drawer?.dataset.sectionId) || []; } catch (error) {}
        const response = await fetch(`${form.action}.js`, { method: 'POST', signal: controller.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: 1 }], sections: sections.map(section => section.id) }) });
        outcomeUnknown = response.ok;
        const data = await response.json();
        if (!response.ok) throw new Error('cart response');
        message.textContent = this.dataset.cartAdded; message.hidden = false; slot.querySelector('[data-cart-link]').hidden = false;
        try {
        sections.forEach(section => {
          const target = document.querySelector(section.selector);
          if (!target || !data.sections?.[section.id]) return;
          const parsed = new DOMParser().parseFromString(data.sections[section.id], 'text/html');
          const source = parsed.querySelector(section.selector); if (source) target.innerHTML = source.innerHTML;
        });
        if (drawer) { drawer.isOpen = true; document.getElementById('CartDrawer__Wrapper')?.classList.add('is-visible'); }
        window.xCartHelper?.updateCurrentCountItem();
        if (typeof CART_EVENT !== 'undefined') document.dispatchEvent(new CustomEvent(CART_EVENT.cartUpdate, { bubbles: true, detail: { isItemCountChanged: true } }));
        } catch (error) { slot.querySelector('[data-cart-link]').hidden = false; }
      } catch (error) {
        message.textContent = outcomeUnknown ? this.dataset.cartUncertain : this.dataset.cartError;
        message.hidden = false;
        if (outcomeUnknown) slot.querySelector('[data-cart-link]').hidden = false;
      }
      finally { clearTimeout(timeout); button.disabled = false; this.cartBusy = false; this.tick(); }
    }
    reminderContent(stop, now = this.now()) {
      const escape = value => value.replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
      const stamp = value => new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
      // Fold at 75 UTF-8 octets without cutting a Hungarian character in half.
      const fold = line => {
        let result = '', bytes = 0;
        for (const character of line) {
          const code = character.codePointAt(0);
          const size = code < 128 ? 1 : code < 2048 ? 2 : code < 65536 ? 3 : 4;
          if (bytes + size > 75) { result += '\r\n '; bytes = 1; }
          result += character; bytes += size;
        }
        return result;
      };
      return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//NUTRIO//November//HU','CALSCALE:GREGORIAN','BEGIN:VEVENT',`UID:bn-${stop.dataset.round}-2026@nutrio.hu`,`DTSTAMP:${stamp(now)}`,`DTSTART:${stamp(stop.dataset.start)}`,`DTEND:${stamp(Date.parse(stop.dataset.start) + 15 * 60000)}`,`SUMMARY:${escape(this.dataset.calendarTitle + ' – ' + stop.dataset.title)}`,`DESCRIPTION:${escape(this.dataset.calendarDescription)}`,'URL:https://www.nutrio.hu/','BEGIN:VALARM','TRIGGER:-PT15M','ACTION:DISPLAY',`DESCRIPTION:${escape(this.dataset.calendarTitle)}`,'END:VALARM','END:VEVENT','END:VCALENDAR',''].map(fold).join('\r\n');
    }
    saveReminder() {
      if (this.state(this.selected) !== 'upcoming') return;
      const url = URL.createObjectURL(new Blob([this.reminderContent(this.selected)], { type: 'text/calendar;charset=utf-8' }));
      const link = document.createElement('a'); link.href = url; link.download = `nutrio-november-${this.selected.dataset.round}.ics`;
      link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  }
  customElements.define('nutrio-offer-calendar', NutrioOfferCalendar);
}
  } catch(e) { console.error(e); }
})();

})();
